import React, { useEffect, useState, useContext } from 'react';

import { useFetch } from 'src/lib/FetchContext';

import { PostComment } from 'src/components/Comments/PostComment/PostComment';
import { Comment } from 'src/components/Comments/Comment/Comment';
import { Button, cn, Typography } from '@riac/design-system';

import { LoginContext } from 'src/lib/LoginContext';
import { AccountContext } from 'src/lib/AccountContext';

export type CommentsProps = React.PropsWithChildren<{
  post: any,
  comments: any,
  className?: string,
}>;

export const Comments = ({ post, comments, className }: CommentsProps) => {
  const { fetch } = useFetch();
  const { isLoggedIn } = useContext(LoginContext);
  const { account, getAccount, isAdmin } = useContext(AccountContext);
  const [pendingAdmin, setPendingAdmin] = useState([]);

  const getComments = async () => {
    // Get additional comments for pending or admin
    if(isLoggedIn) {
      const additionalReq = await fetch(`/api/ghost/getBlogComments${isAdmin ? 'Admin' : 'Pending'}/${post.id}`, { credentials: 'include' });
      const additional = isLoggedIn ? await additionalReq.json() : [];
      setPendingAdmin(additional);
    }
  };

  useEffect(() => {
    getAccount();
    getComments();
  }, []);

  return (
    <div className = {cn('flex flex-col gap-5 w-prose flex-1', className)}>
      <Typography size='lg' weight='bold' heading>Comments</Typography>
      {comments.length > 0 && comments.map((comment) => (
        <Comment
          key={comment.ID}
          post={post}
          update={() => getComments()}
          comment={comment}
          account={account}
        />
      ))}
      {pendingAdmin.length > 0 && pendingAdmin.map((comment) => (
        <Comment
          key={comment.ID}
          post={post}
          update={() => getComments()}
          comment={comment}
          account={account}
          status='pending'
        />
      ))}
      <div className='bg-surface-dark p-6 flex flex-col'>
        {isLoggedIn && <PostComment post={post} update={() => getComments()} account={account} />}
        {!isLoggedIn && <p>Please <Button variant='link' className='p-0' to='/login'>login</Button> to post a comment.</p>}
      </div>
    </div>
  );
};
